/**
 * Where a contract page was opened FROM — so its breadcrumb and back button
 * lead there, not always to the legacy "Rentals" list.
 *
 * The contract pages (/contract-live, /contract-summary, /contract,
 * /rental-details, /rental-log) are shared by three doors: Operations → Sites,
 * Sales → Contracts, Operations → Machine Contracts, plus the legacy /rentals
 * page. The door records itself here when it opens a contract; the pages read
 * it back. sessionStorage so it survives a reload and the hops between the
 * contract pages themselves (live → summary → machine → logs).
 */
const KEY = 'contractOrigin';

export const CONTRACT_ORIGINS = {
    sites:    { label: 'Sites',             path: '/operations/sites' },
    machines: { label: 'Machine Contracts', path: '/operations/machine-contracts' },
    sales:    { label: 'Contracts',         path: '/sales/contracts' },
    rentals:  { label: 'Rentals',           path: '/rentals' },
};

/** Record the door a contract is being opened from. */
export const setContractOrigin = (key) => {
    try { sessionStorage.setItem(KEY, CONTRACT_ORIGINS[key] ? key : 'rentals'); } catch { /* private mode */ }
};

/** The door for the page the user is on now (used by the shared RentalPage engine). */
export const originForPath = (pathname = '') => {
    if (pathname.startsWith('/operations/sites')) return 'sites';
    if (pathname.startsWith('/operations/')) return 'machines';
    if (pathname.startsWith('/sales/')) return 'sales';
    return 'rentals';
};

/** { label, path } of where to go back to. */
export const getContractOrigin = () => {
    let key = 'rentals';
    try { key = sessionStorage.getItem(KEY) || 'rentals'; } catch { /* private mode */ }
    return CONTRACT_ORIGINS[key] || CONTRACT_ORIGINS.rentals;
};
